import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useConfiguration } from "../hooks/useConfiguration";
import { useUnsavedChanges } from "../hooks/useUnsavedChanges";
import { STEPS } from "../lib/steps";
import { Surface } from "./Surface";

export function StepNav() {
  const { stepIndex } = useConfiguration();
  const { requestStep } = useUnsavedChanges();

  return (
    <Surface
      sx={{
        width: { xs: "100%", md: 260 },
        flexShrink: 0,
        position: { md: "sticky" },
        top: 16,
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          color: "text.secondary",
          mb: 1.25,
        }}
      >
        Step {stepIndex + 1} of {STEPS.length}
      </Typography>
      <Stack spacing={0.25}>
        {STEPS.map((step, index) => (
          <Box
            key={step.id}
            component="button"
            onClick={() => requestStep(index)}
            sx={{
              textAlign: "left",
              border: "none",
              bgcolor: index === stepIndex ? "#eff8ff" : "transparent",
              borderLeft:
                index === stepIndex
                  ? "3px solid #1a4f8c"
                  : "3px solid transparent",
              px: 1.25,
              py: 0.85,
              cursor: "pointer",
              opacity: index === stepIndex ? 1 : 0.72,
            }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: "0.85rem" }}>
              {index + 1}. {step.title}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Surface>
  );
}
